import { makeSelectors } from '@utils/css';

const transitionDurationMs = 225;
const modifiers = makeSelectors({
  greyedOut: "_275g1sbkr2z",
  expanded: "_275ermj25b"
});
const item = "_275i7ejwfk";
const rowSizingCls = "_275r1bznxxl";
const nestedContent = "_275n1okjmqe";
const showAnswersButton = "_275s1bg75ux";
const mobileRowHeading = "_275m9z2n8d";
const mobileCell = "_275m17dw6g3";
const mobileDialogCell = "_275m187no9j";
const mobileActionsContainer = "_275mjddp1h";

export { item, mobileActionsContainer, mobileCell, mobileDialogCell, mobileRowHeading, modifiers, nestedContent, rowSizingCls, showAnswersButton, transitionDurationMs };
import "./table.item.style.linaria.module.css";
//# sourceMappingURL=table.item.style.js.map
